import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import Hero from './components/Hero';
import Demo from './components/Demo';
import Features from './components/Features';
import Comparison from './components/Comparison';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Bonuses from './components/Bonuses';
import CTA from './components/CTA';

function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { label: '👉 APERTE AQUI E CONHEÇA NOSSA LOJA', to: '/produtos', color: 'orange' },
  ];

  return (
    <nav className="main-nav">
      <div className="main-nav-inner">
        <Link to="/" className="nav-brand">
          <img src="https://static.lumi.new/d2/d2c11a555f13515f311cbfe03b2f4b1a.webp" alt="Logo" className="nav-brand-logo" />
          <span className="nav-brand-text">Mestre Lovable</span>
        </Link>

        <div className="nav-links">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`nav-button nav-button-${link.color}`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}

function App() {
  useEffect(() => {
    // YouTube embed is used; no PandaPlayer initialization needed
  }, []);

  return (
    <div className="app-root">
      {/* Easter Egg Banner */}
      <div className="easter-egg-banner">
        <div className="section-inner">
          <p className="easter-egg-text">
            <strong>🚀 SOMOS A ÚNICA EXTENSÃO FUNCIONANDO ATUALMENTE 100%</strong>
          </p>
        </div>
      </div>

      {/* Navigation Bar */}
      <NavBar />
      
      {/* Hero with VSL */}
      <Hero />

      {/* Video Section */}
      <section className="video-section">
        <div className="section-inner">
          <div style={{ position: 'relative', paddingTop: '56.25%' }}>
            <iframe
              src="https://www.youtube.com/embed/JUexihu0ZS8?rel=0&modestbranding=1"
              style={{ border: 'none', position: 'absolute', top: 0, left: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen={true}
              width="100%"
              height="100%"
            />
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <Testimonials />

      {/* Demo / How it works */}
      <Demo />

      {/* Features */}
      <Features />

      {/* Comparison */}
      <Comparison />

      {/* Bonuses */}
      <Bonuses />

      {/* FAQ */}
      <FAQ />

      {/* Pricing */}
      <Pricing />

      {/* CTA Final */}
      <CTA />

      {/* WhatsApp Community */}
      <section className="whatsapp-community-section">
        <div className="section-inner">
          <div className="whatsapp-box">
            <img src="https://static.lumi.new/7d/7df50f3c4814663718aef228e8d0bba7.webp" alt="WhatsApp" className="whatsapp-logo" />
            <h2 className="whatsapp-title -mt-[13px] mr-[0px] -mb-[4px]">Entre de Graça na Comunidade Mestre do Lovable</h2>
            <p className="whatsapp-subtitle">Mais de 1000 membros ativos compartilhando dicas, truques e hacks do Lovable no WhatsApp - Melhor network de Lovable</p>
            <a href="https://chat.whatsapp.com/Cv5J7KCEQl61OZf86awYd3" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
              <img src="https://static.lumi.new/7d/7df50f3c4814663718aef228e8d0bba7.webp" alt="WhatsApp" className="whatsapp-button-icon" />
              Entrar na Comunidade Grátis
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="site-footer">
        <div className="section-inner">
          <div className="footer-brand">
            <img src="https://static.lumi.new/00/0011bb058a2686e447915d0083474f56.webp" alt="Mestre Lovable Infinity" className="footer-logo" />
            <span className="footer-name">Mestre Lovable Infinity</span>
          </div>
          <p className="footer-copy">&copy; 2026 Mestre do Lovable - Todos os direitos reservados</p>
          <div className="footer-links">
            <a href="/privacy" className="footer-link">Política de Privacidade</a>
          </div>
          







        </div>
      </footer>
    </div>);

}

export default App;